module.exports = __webpack_public_path__ + "static/img/icon-exchange.86e1d13e.png";